var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Sections"},[_c('draggable',{attrs:{"element":'ul'},model:{value:(_vm.sections),callback:function ($$v) {_vm.sections=$$v},expression:"sections"}},_vm._l((_vm.sections),function(section,index){return _c('li',{key:index},[_c('section-item',{attrs:{"section":section,"sectionindex":index}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }